import withStyles from "@material-ui/core/styles/withStyles";

import { confirmAlert } from "react-confirm-alert";

// @material-ui/icons
import Add from "@material-ui/icons/Add";
import AddAlert from "@material-ui/icons/AddAlert";
import Edit from "@material-ui/icons/Edit";
import Delete from "@material-ui/icons/Delete";
import WhereToVote from "@material-ui/icons/WhereToVote";
import { FaCampground } from "react-icons/fa";
import {
  fetchGetCampsiteDetails,
  fetchGetCampsites,
  fetchDeleteCampsite,
  fetchAddCampsite,
  fetchUpdateCampsite
} from "actions/campsite";
import { fetchGetCommunityDetails } from "actions/community";
import { fetchGetNearCities } from "actions/city";
import {
  RESET_CAMPSITE,
  SET_CAMPSITES_SORTED,
  SET_DELETE_CAMPSITE_CONFIRMATION_NAME
} from "actions/types";

// core components
import Card from "components/Card/Card";
import CardBody from "components/Card/CardBody";
import CardHeader from "components/Card/CardHeader";
import CardFooter from "components/Card/CardFooter";
import CardIcon from "components/Card/CardIcon";
import Button from "components/CustomButtons/Button";
import GridContainer from "components/Grid/GridContainer";
import GridItem from "components/Grid/GridItem";
import Snackbar from "components/Snackbar/Snackbar";
import CustomInput from "components/CustomInput/CustomInput";
import Wizard from "components/DigiHapi/Wizard";

import extendedTablesStyle from "assets/jss/material-dashboard-pro-react/views/extendedTablesStyle";
import { beigeColor } from "assets/jss/material-dashboard-pro-react";

// core components
import PropTypes from "prop-types";
import React from "react";
import { connect } from "react-redux";
import ReactTable from "react-table";
import { bindActionCreators } from "redux";
import Components from "./CampsitesPage";
import Step1 from "./Step1";
import Step2 from "./Step2";
import Step3 from "./Step3";

import canUseDOM from "can-use-dom";

const style = {
  ...extendedTablesStyle,
  customUI: {
    backgroundColor: beigeColor[1],
    maxWidth: "400px",
    borderRadius: "10px",
    padding: 10
  },
  w100: {
    width: "100%"
  },
  floatRight: {
    float: "right"
  },
  justifyContentSpaceAround: {
    display: "flex",
    justifyContent: "space-around"
  },
  descriptionContainer: {
    height: "60px"
  }
};

const geolocation =
  canUseDOM && navigator.geolocation
    ? navigator.geolocation
    : {
        getCurrentPosition(success, failure) {
          failure("Your browser doesn't support geolocation.");
        }
      };

class CampsitesWizard extends React.Component {
  fetchAddCampsite = () => {
    const {
      fetchAddCampsite,
      name,
      customUri,
      address,
      zipCode,
      city,
      webSiteUrl,
      mail,
      loc,
      phone,
      fax,
      registerkey,
      files,
      channels,
      citiesTags
    } = this.props;

    fetchAddCampsite({
      name,
      customUri,
      address,
      zipCode,
      city,
      webSiteUrl,
      mail,
      loc,
      phone,
      fax,
      registerkey,
      files,
      channelsIds: Object.values(channels)
        .filter(obj => obj.selected)
        .map(obj => obj._id),
      citiesIds: Object.values(citiesTags)
        .filter(obj => obj.selected)
        .map(obj => obj._id)
    });
  };

  fetchUpdateCampsite = () => {
    const {
      fetchUpdateCampsite,
      _id,
      name,
      customUri,
      registerkey,
      address,
      zipCode,
      city,
      webSiteUrl,
      mail,
      loc,
      phone,
      fax,
      files,
      logoUri,
      mapUri,
      mapSmallUri,
      equipmentsIds,
      channels,
      citiesTags
    } = this.props;

    fetchUpdateCampsite({
      _id,
      name,
      customUri,
      registerkey,
      address,
      zipCode,
      city,
      webSiteUrl,
      mail,
      loc,
      phone,
      fax,
      files,
      logoUri,
      mapUri,
      mapSmallUri,
      equipmentsIds,
      channelsIds: Object.values(channels)
        .filter(obj => obj.selected)
        .map(obj => obj._id),
      citiesIds: Object.values(citiesTags)
        .filter(obj => obj.selected)
        .map(obj => obj._id)
    });
  };

  render() {
    const { update, isFetching, onClose } = this.props;
    return (
      <GridItem xs={12} sm={12}>
        <Wizard
          onClose={onClose}
          isFetching={isFetching}
          validate
          steps={[
            {
              stepName: "Illustration",
              stepComponent: Step1,
              stepId: "picture"
            },
            {
              stepName: "Informations",
              stepComponent: Step2,
              stepId: "infos"
            },
            {
              stepName: "Localisation",
              stepComponent: Step3,
              stepId: "localisation"
            }
          ]}
          title={update ? "Mise à jour d'un camping" : "Ajout d'un camping"}
          subtitle=""
          finishButtonClick={
            update ? this.fetchUpdateCampsite : this.fetchAddCampsite
          }
        />
      </GridItem>
    );
  }
}

class CampsitesPage extends React.Component {
  state = {
    br: false,
    color: "info",
    message: null,
    wizard: null,
    alert: null,
    name: ""
  };

  componentDidMount() {
    this.props.fetchGetCampsites();
  }

  componentDidUpdate(prevProps, prevState) {
    const {
      fetchGetCampsites,
      snackErrorMsg,
      snackInfoMsg,
      newWizard,
      page,
      limit,
      sorted
    } = this.props;

    if (snackErrorMsg && prevProps.snackErrorMsg !== snackErrorMsg) {
      this.autoCloseMessage();
    }

    if (snackInfoMsg && prevProps.snackInfoMsg !== snackInfoMsg) {
      this.setState({
        wizard: null
      });
      fetchGetCampsites(page, limit, sorted);
      this.autoCloseMessage();
    }

    if (newWizard && prevProps.newWizard !== newWizard) {
      this.addWizard(newWizard === "update");
    }
  }

  hideAlert = () => {
    this.setState({
      br: false
    });
  };

  autoCloseMessage = () => {
    const { snackErrorMsg, snackInfoMsg } = this.props;

    this.setState({
      br: true,
      message: snackInfoMsg ? snackInfoMsg : snackErrorMsg,
      color: snackInfoMsg ? "info" : "danger"
    });

    if (snackInfoMsg) {
      setTimeout(this.hideAlert, 5000);
    }
  };

  onClose = () => {
    this.setState({
      wizard: null
    });
    this.props.dispatch({
      type: RESET_CAMPSITE
    });
  };

  addWizard = (update = true) => {
    this.setState({
      wizard: (
        <Components.CampsitesWizard update={update} onClose={this.onClose} />
      )
    });
  };

  changeCommunity = id => {
    this.props.fetchGetCommunityDetails(id);
  };

  editCampsite = id => {
    this.props.fetchGetCampsiteDetails(id);
  };

  deleteCampsite = id => {
    this.props.fetchDeleteCampsite(id, this.props.deleteConfirmationName);
  };

  getRoundButtons = (id, name) => {
    const { classes } = this.props;
    return [
      { color: "success", icon: WhereToVote, onClick: this.changeCommunity },
      { color: "brown", icon: Edit, onClick: this.editCampsite },
      { color: "danger", icon: Delete, onClick: this.delete }
    ].map((prop, key) => {
      return (
        <Button
          round
          color={prop.color}
          className={classes.actionButton + " " + classes.actionButtonRound}
          key={key}
          disabled={this.state.wizard ? true : false}
          onClick={() => prop.onClick(id, name)}
        >
          <prop.icon className={classes.icon} />
        </Button>
      );
    });
  };

  getCampsites = () => {
    const { campsitesNames } = this.props;

    const campsitesObj = Object.values(campsitesNames).map(({ _id, name }) => {
      return {
        name,
        actions: (
          <div className="actions-right">{this.getRoundButtons(_id, name)}</div>
        )
      };
    });
    return campsitesObj;
  };

  delete = (communityId, campsiteName) => {
    const { classes, dispatch } = this.props;
    confirmAlert({
      customUI: ({ onClose }) => {
        return (
          <div className={classes.customUI}>
            <h2>Confirmation</h2>
            <p>Êtes-vous sûr de vouloir supprimer le camping ?</p>
            {`Confirmer la suppression du camping en saisisant le nom du camping ${campsiteName}`}
            <CustomInput
              labelText="Camping ..."
              id="camping"
              formControlProps={{
                fullWidth: true
              }}
              inputProps={{
                // value: deleteConfirmationName,
                onChange: e =>
                  dispatch({
                    type: SET_DELETE_CAMPSITE_CONFIRMATION_NAME,
                    value: e.target.value
                  })
              }}
            />
            <div className={classes.justifyContentSpaceAround}>
              <Button
                onClick={() => {
                  onClose();
                }}
              >
                Annuler
              </Button>
              <Button
                color="danger"
                onClick={() => {
                  this.deleteCampsite(communityId);
                  onClose();
                }}
              >
                Supprimer
              </Button>
            </div>
          </div>
        );
      }
    });
  };

  render() {
    const { color, message, alert } = this.state;
    const {
      classes,
      isFetchingList,
      dispatch,
      page,
      totalPages,
      limit,
      sorted,
      fetchGetCampsites,
      fetchGetNearCities
    } = this.props;

    return (
      <GridContainer justify="center">
        {alert}
        <GridItem xs={12}>
          <Card>
            <CardHeader icon>
              <CardIcon color="primary">
                <FaCampground />
              </CardIcon>
              <h4 className={classes.cardIconTitle}>Campings</h4>
            </CardHeader>
            <CardBody>
              <ReactTable
                data={this.getCampsites()}
                filterable
                columns={[
                  {
                    Header: "Nom",
                    accessor: "name",
                    sortable: true,
                    filterable: false
                  },
                  {
                    Header: "Actions",
                    accessor: "actions",
                    sortable: false,
                    filterable: false
                  }
                ]}
                showPaginationTop
                showPaginationBottom={false}
                manual
                onFetchData={state => {
                  if (
                    page !== state.page + 1 ||
                    limit !== state.pageSize ||
                    sorted !== state.sorted
                  ) {
                    dispatch({
                      type: SET_CAMPSITES_SORTED,
                      value: state.sorted
                    });
                    fetchGetCampsites(
                      state.page + 1,
                      state.pageSize,
                      state.sorted
                    );
                  }
                }}
                loading={isFetchingList}
                defaultPageSize={limit}
                defaultSorted={sorted}
                page={page - 1}
                pageSizeOptions={[5, 10, 15, 20, 40, 80]}
                pages={totalPages}
                previousText="Précédent"
                nextText="Suivant"
                rowsText="Lignes"
                noDataText="Aucuns campings"
                ofText="sur"
                loadingText="Chargement..."
                className="-striped -highlight"
              />
            </CardBody>
            <CardFooter product>
              <div className={classes.w100}>
                <Button
                  className={classes.floatRight}
                  color="primary"
                  onClick={() => {
                    geolocation.getCurrentPosition(
                      position => {
                        fetchGetNearCities(
                          position.coords.longitude,
                          position.coords.latitude,
                          [
                            "CampsiteGooddealChannel",
                            "CampsiteEventChannel",
                            "WeatherChannel"
                          ]
                        );
                        this.addWizard(false);
                      },
                      () => {
                        fetchGetNearCities(0, 0, [
                          "CampsiteGooddealChannel",
                          "CampsiteEventChannel",
                          "WeatherChannel"
                        ]);
                        this.addWizard(false);
                      }
                    );
                  }}
                  disabled={Boolean(this.state.wizard)}
                >
                  <Add /> {"Ajout d'un camping"}
                </Button>
              </div>
            </CardFooter>
          </Card>
        </GridItem>
        {this.state.wizard}
        <Snackbar
          place="br"
          color={color}
          icon={AddAlert}
          message={message ? message : ""}
          open={this.state.br}
          closeNotification={() => this.setState({ br: false })}
          close
        />
      </GridContainer>
    );
  }
}

CampsitesPage.propTypes = {
  classes: PropTypes.object
};

const mapStateToProps = state => {
  const {
    _id,
    isFetching,
    isFetchingList,
    name,
    address,
    zipCode,
    city,
    webSiteUrl,
    mail,
    loc,
    phone,
    fax,
    registerkey,
    files,
    snackInfoMsg,
    snackErrorMsg,
    logoUri,
    mapUri,
    mapSmallUri,
    newWizard,
    equipmentsIds,
    deleteConfirmationName,
    channels,
    citiesTags,
    customUri,
    campsitesNames,
    page,
    hasNextPage,
    nextPage,
    totalPages,
    totalDocs,
    limit,
    sorted
  } = state.campsiteReducer;

  return {
    _id,
    isFetching,
    isFetchingList,
    name,
    address,
    zipCode,
    city,
    webSiteUrl,
    mail,
    loc,
    phone,
    fax,
    registerkey,
    files,
    snackInfoMsg,
    snackErrorMsg,
    logoUri,
    mapUri,
    mapSmallUri,
    newWizard,
    equipmentsIds,
    deleteConfirmationName,
    channels,
    citiesTags,
    customUri,
    campsitesNames,
    page,
    hasNextPage,
    nextPage,
    totalPages,
    totalDocs,
    limit,
    sorted
  };
};

const mapDispatchToProps = dispatch => {
  let actions = bindActionCreators(
    {
      fetchGetCampsites,
      fetchGetCampsiteDetails,
      fetchDeleteCampsite,
      fetchAddCampsite,
      fetchUpdateCampsite,
      fetchGetCommunityDetails,
      fetchGetNearCities
    },
    dispatch
  );
  return { ...actions, dispatch };
};

export default {
  CampsitesPage: connect(
    mapStateToProps,
    mapDispatchToProps
  )(withStyles(style)(CampsitesPage)),
  CampsitesWizard: connect(
    mapStateToProps,
    mapDispatchToProps
  )(withStyles(style)(CampsitesWizard))
};
